import { render, staticRenderFns } from "./ReassignSubmission.vue?vue&type=template&id=cf1d7832&scoped=true&"
import script from "./ReassignSubmission.vue?vue&type=script&lang=js&"
export * from "./ReassignSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d7832",
  null
  
)

export default component.exports